/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RewardTypes } from './reward-types';


export interface UpdateUserMiningCommissionItem { 
    currencyId: number;
    rewardType: RewardTypes;
    commission: number;
}



